import {useMemo} from "react";

import SimpleMarkdown, {
    type Parser,
    type ReactOutput,
} from "@khanacademy/simple-markdown";
import {Text} from "@khanacademy/wonder-blocks-core";

import {mathRule} from "./rules/math.tsx";
import {textRule} from "./rules/text.ts";

const rules = {
    text: textRule,
    inlineMath: mathRule,
    inlineCode: SimpleMarkdown.defaultRules.inlineCode,
    em: SimpleMarkdown.defaultRules.em,
    u: SimpleMarkdown.defaultRules.u,
    strong: SimpleMarkdown.defaultRules.strong,
    link: SimpleMarkdown.defaultRules.link,
    image: SimpleMarkdown.defaultRules.image,
};

export default function InlineMarkdown(props: {text: string}) {
    const {text} = props;

    const render: ReactOutput = useMemo(
        () => SimpleMarkdown.outputFor(rules, "react"),
        [],
    );

    const parse: Parser = useMemo(
        () => SimpleMarkdown.parserFor(rules, {inline: true}),
        [],
    );

    if (!text) {
        return null;
    }

    return <Text tag="span">{render(parse(text))}</Text>;
}
